module.exports = __webpack_public_path__ + "static/img/alpaga-04.0de2b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-04.png
// module id = 63
// module chunks = 0